<template>
  <el-dialog v-model="visible" append-to-body :show-close="false" width="564px" :close-on-click-modal="false">
    <div class="data-sync-success">
      <div class="success-icon">
        <template v-if="upperLimit">
          <i class="WSiconfont sWSicon-a-Frame4273239781"></i>
        </template>
        <template v-else>
          <i class="WSiconfont WSicon-a-Frame427323978"></i>
        </template>
      </div>
      <template v-if="upperLimit">
        <template v-if="config.bindf">
          <div v-html="config.bindf"></div>
        </template>
        <template v-else>
          <div v-html="limitText" class="success-tips" />
        </template>
        <div class="success-btn">
          <el-button type="primary" @click="upLimit">确认</el-button>
        </div>
      </template>
      <template v-else>
        <div class="success-title">同步完成</div>
        <div class="success-tips">
          <template v-if="dataSyncConfig.imports === 0">
            本次同步数据完成<span>{{ info.addnum }}</span>条<template v-if="isError">,失败<span>{{ info.errornum }}</span>条</template>
          </template>
          <template v-if="dataSyncConfig.imports === 1">
            本次同步数据完成<span>{{ info.updatenum }}</span>条<template v-if="isError">,失败<span>{{ info.errornum }}</span>条</template>
          </template>
          <template v-if="dataSyncConfig.imports === 2">
            本次同步数据完成<span>{{ info.addnum }}</span>条<template>修改<span>{{ info.updatenum }}</span>条</template><template v-if="isError">,失败<span>{{ info.errornum }}</span>条</template>
          </template>
        </div>
        <div class="success-tips2" @click="downLoad">
          <template v-if="isError">
            下载失败记录
          </template>
        </div>
        <div class="success-btn">
          <el-button type="primary" @click="close">确认 </el-button>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { filePreview } from '@/api/global'
import { dealText } from '@/api/common'
export default {
  // 组件名称
  name: 'dataSync',
  // 组件参数 接收来自父组件的数据
  props: {
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      visible: false,
      isError: false,
      upperLimit: false,
      config: {},
      info: {},
      dataSyncConfig: {},
      totalConfig: {},
      limitText: ''
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
  },
  // 组件方法
  methods: {
    open(config = {}) {
      this.upperLimit = false
      this.config = {} 
      this.totalConfig = {}
      for (const key in config) {
        this[key] = config[key]
      }
      if (config.info.errornum > 0) {
        this.isError = true
      }

      if (this.upperLimit) {
        this.limitText = dealText({ text: this.dataSyncConfig.maxSyncNumConfig })
      }

      this.totalConfig = config

      this.visible = true
    },
    downLoad() {
      if (this.isError && this.info.failpath) {
        filePreview({ url: this.info.failpath }, true)
      }
    },
    upLimit() {
      this.$emit('upLimit', this.totalConfig)
      this.visible = false
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  },
}
    </script> 

<style scoped lang="scss">
::v-deep .el-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 18px 25px;
  }
}
.data-sync-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  .success-icon {
    .sWSicon-a-Frame4273239781 {
      color: #F2B32C;
    }
    .WSicon-a-Frame427323978 {
      color: #52C41A;
    }
    i {
      font-size: 80px;
    }
  }
  .success-title {
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    margin-top: 12px;
  }
  .success-tips {
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    margin: 16px 0;
  }
  .success-tips2 {
    color: #D0021B;
    font-weight: 400;
    font-size: 14px;
    height: 17px;
    line-height: 17px;
    cursor: pointer;
  }
  .success-btn {
     margin-top: 14px;
  }
}
</style>
